// client/src/components/admin/project/CompletedProjectSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function CompletedProjectSummary({ interactive = false }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  // 완료된 프로젝트 목록 조회 (최대 5개)
  const fetchCompletedProjects = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/completed-list?limit=5`, {
        credentials: 'include'
      });
      const data = await res.json();
      
      if (data.ok) {
        const list = data.projects || [];
        setCount(data.total || 0);
        setProjects(list);
      }
    } catch (error) {
      console.error('완료된 프로젝트 목록 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompletedProjects();
  }, []);

  // 날짜 포맷팅
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <div className="completed-project-summary">
      {/* 헤더 */}
      <div className="completed-project-summary__header">
        <h3 className="completed-project-summary__title">
          완료된 프로젝트 보기
        </h3>
        {count > 0 && (
          <span className="completed-project-summary__badge">
            {count}
          </span>
        )}
      </div>

      {/* 로딩 */}
      {loading && (
        <div className="completed-project-summary__loading">
          로딩 중...
        </div>
      )}

      {/* 데이터 없음 */}
      {!loading && projects.length === 0 && (
        <div className="completed-project-summary__empty">
          완료된 프로젝트가 없습니다.
        </div>
      )}

      {/* 프로젝트 목록 */}
      {!loading && projects.length > 0 && (
        <div className="completed-project-summary__list">
          {projects.map((project, index) => (
            <div 
              key={project.id}
              className={`completed-project-summary__item ${
                index < projects.length - 1 ? 'completed-project-summary__item--border' : ''
              }`}
            >
              <div className="completed-project-summary__item-content">
                <div className="completed-project-summary__item-info">
                  <div className="completed-project-summary__item-title">
                    {project.projectNumber} | {project.marketerName}
                  </div>
                  <div className="completed-project-summary__item-date">
                    완료: {formatDate(project.completedAt)}
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {count > 5 && (
            <div className="completed-project-summary__more">
              외 {count - 5}건
            </div>
          )}
        </div>
      )}
    </div>
  );
}

